import { useRoles } from "./improved_components/hooks/use_roles";
import { SearchableDropdown } from "./searchable_dropdown";

export function RoleRestrictionsForm(props: {
	role_ids: string[];
	updateFunc: (role_ids: string[]) => void;
	disabled?: boolean;
}) {
	const roles = useRoles();

	const mentionables =
		roles?.filter((val) => props.role_ids.includes(val.id)) ?? [];

	return (
		<SearchableDropdown
			options={roles.filter((val) => !val.is_everyone_or_here) ?? []}
			placeholder={props.disabled ? "Disabled" : "None"}
			handleChange={(mentionables) =>
				props.updateFunc(mentionables.map((val) => val.id))
			}
			initial_mentions={mentionables.filter(
				(val) => !val.is_everyone_or_here
			)}
			ignore_invalid_permissions={true}
			loading={!roles}
			disabled={props.disabled}
		/>
	);
}
